import React from 'react';

/**
 * チャットサイドパネル上部のスリムバー（全チャット共通）。
 * 旧「詳細パネル」ラベル行＋丸ピル「閉じる」を、文脈ラベル＋アイコン＋
 * ゴーストの折りたたみボタン 1 本に集約する。高さは 40px 固定。
 *
 * @param {string} icon        Font Awesome のアイコンクラス（例: 'fa-calendar-days'）
 * @param {string} label       文脈ラベル（例: 'イベント情報' / 'アーティスト情報' / 'チャット情報'）
 * @param {Function} onCollapse 折りたたみハンドラ
 */
export default function ChatSidePanelHeader({
  icon = '',
  label = 'チャット情報',
  onCollapse,
}) {
  const collapseLabel = `${label}パネルを閉じる`;

  return (
    <div className="csp-bar">
      <span className="csp-bar__ctx">
        {icon ? <i className={`csp-bar__ico fa-solid ${icon}`} aria-hidden="true" /> : null}
        <span className="csp-bar__label">{label}</span>
      </span>
      <button
        type="button"
        className="csp-collapse"
        onClick={onCollapse}
        aria-label={collapseLabel}
        title={collapseLabel}
      >
        <i className="fa-solid fa-angles-right" aria-hidden="true" />
      </button>
    </div>
  );
}
